import { ResultSetHeader } from './../../models/result-set-header';
import { DishIconDescription, DishIconDescriptionString } from '../../models';
import http, { HttpSuccessOrErrorType } from '../http';
export default {

    /**
     * 创建过敏源/菜品标识
     * @param params 参数
     */
    async create_dish_icon_description(params: DishIconDescription & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.post(`/restaurant/${string_id}/dish_icon_description`, {
            ...rest
        })
    },

    /**
     * 修改过敏源/菜品标识
     * @param params 参数
     */
    async patch_dish_icon_description(params: DishIconDescription & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id, ...rest } = params;
        return await http.patch(`/restaurant/${string_id}/dish_icon_description/${id}`, {
            ...rest
        })
    },

    /**
     * 查询 过敏源/菜品标识列表
     * @param params 参数
     */
    async get_restaurant_string_id_dish_icon_description_condition(params: DishIconDescription & { string_id: string }): Promise<HttpSuccessOrErrorType<Array<DishIconDescription>>> {
        const { string_id, ...rest } = params;
        return await http.get(`/restaurant/${string_id}/dish_icon_description/condition`, {
            params: {
                ...rest
            }
        })
    },

    /**
     * 查询单个 过敏源/菜品标识
     * @param params 参数
     */
    async get_dish_icon_description_id(params: DishIconDescription & { string_id: string }): Promise<HttpSuccessOrErrorType<DishIconDescription>> {
        const { string_id, id } = params;
        return await http.get(`/restaurant/${string_id}/dish_icon_description/${id}`)
    },

    /**
     * 删除单个 过敏源/菜品标识
     * @param params 参数
     */
    async delete_dish_icon_description_id(params: DishIconDescription & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, id } = params;
        return await http.delete(`/restaurant/${string_id}/dish_icon_description/${id}`)
    },

    /**
     * 批量删除 过敏源/菜品标识
     * @param params 参数
     */
    async delete_dish_icon_descriptions(params: { string_id: string, ids: number[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ids } = params;
        return await http.delete(`/restaurant/${string_id}/dish_icon_descriptions`, {
            data: {
                ids
            }
        })
    },

    /**
     * 过敏源/菜品标识动态国际化
     * @param params 参数
     */
    async dish_icon_description_strings(params: { string_id: string, request: DishIconDescriptionString[] }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, request } = params;
        return await http.post(`/restaurant/${string_id}/dish_icon_description/dish_icon_description_strings`, request)
    },

}